import HighlightText from './src/highlight-text';

export default HighlightText;
